import React from 'react';

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { err?: any }> {
  state = { err: undefined as any };
  static getDerivedStateFromError(err: any) {
    return { err };
  }
  componentDidCatch(error: any, info: any) {
    console.error('Render error', error, info);
    try {
      const Sentry = (window as any).Sentry || undefined;
      Sentry?.captureException?.(error, { extra: { info } });
    } catch {}
  }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: 16, fontFamily: 'ui-sans-serif' }}>
          <h1>We hit a hiccup starting the app.</h1>
          <pre style={{ whiteSpace: 'pre-wrap' }}>
            {String(this.state.err?.message || this.state.err)}
          </pre>
          <p>Try refresh. If this persists, we'll see it in our logs.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
